import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Switch } from '@/components/ui/switch'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { OfferModel } from '@/types'

import { CampaignProductPicker } from '../CampaignProductPicker'

interface Props {
  rules: Partial<OfferModel.SingleProductRules>
  onChange: (rules: Partial<OfferModel.SingleProductRules>) => void
}

export const SingleProductEditor = ({ rules, onChange }: Props) => {
  const update = (patch: Partial<OfferModel.SingleProductRules>) =>
    onChange({ ...rules, ...patch })

  return (
    <div className="space-y-4">
      <CampaignProductPicker
        label="Select product"
        selectedIds={rules.product_id ? [rules.product_id] : []}
        onChange={(ids) => update({ product_id: ids[0] ?? '' })}
        multiple={false}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label>Discount type</Label>
          <Select
            value={rules.discount_type ?? 'percentage'}
            onValueChange={(v) => update({ discount_type: v as OfferModel.DiscountType })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="percentage">Percentage (%)</SelectItem>
              <SelectItem value="cash">Fixed amount</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-1.5">
          <Label>Discount value</Label>
          <Input
            type="number"
            min={0}
            value={rules.discount_value ?? ''}
            onChange={(e) => update({ discount_value: Number(e.target.value) })}
            placeholder={rules.discount_type === 'percentage' ? '0–100' : '0.00'}
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <Switch
          checked={rules.free_delivery ?? false}
          onCheckedChange={(v) => update({ free_delivery: v })}
        />
        <Label>Free delivery</Label>
      </div>
    </div>
  )
}
